// extracted by mini-css-extract-plugin
module.exports = {"factSheetBarChartWrapper":"styles_factSheetBarChartWrapper__2wZ5K"};